module.exports = __webpack_public_path__ + "static/media/BARIcon_MiniSet.52cb1c42.png";